import { render, staticRenderFns } from "./EMR.vue?vue&type=template&id=7bcbbaf3&"
import script from "./EMR.vue?vue&type=script&lang=js&"
export * from "./EMR.vue?vue&type=script&lang=js&"
import style0 from "./EMR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports